import { QuestionnaireStatus } from '@/components/decision-tree';
import { Box } from '@cmpsr/components';
import React from 'react';
import RiskAssessmentSections from './components/risk-assessment-sections/risk-assessment-sections';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';

type RiskAssessmentTabProps = {
  assessmentProgress: number;
  questionnaireStatus: QuestionnaireStatus;
  iDontKnowAnswers: number;
  totalAnsweredQuestions: number;
};

function RiskAssessmentTab({ questionnaireStatus }: RiskAssessmentTabProps) {
  return (
    <DashboardGrid
      pt={{ base: 5, md: 8, lg: 12 }}
      gap={{ base: 4, lg: 8, xl: 9, xxl: 12 }}
      gridTemplateAreas={{
        base: `"aside"
              "main"`,
        lg: `"main aside"`,
      }}
    >
      <Box gridArea="main">
        <RiskAssessmentSections questionnaireStatus={questionnaireStatus} />
      </Box>
    </DashboardGrid>
  );
}

export default React.memo(RiskAssessmentTab);
